<!-- Componente de camara: ejecuta metodo capture para almacenar la imagen temporal -->
<template>
    <div>
        <div>
            <div class="text-center">
                <video v-if="!capturado" @click="capture" ref="video">
                </video>
                <canvas width="0" ref="canvas"></canvas>
            </div>
            <div v-if="!capturado" class="text-center">
                <v-chip color="primary lighten-1">
                    Haz click en cualquier
                    parte para
                    capturar la foto
                </v-chip>
            </div>
        </div>

        <v-col v-if="capturado" class="d-flex flex-column justify-center align-center ma-0 pa-0">
            <v-btn @click="cargarFoto" class="pa-5" width="163" color="primary" elevation="0">
                <v-icon class="mr-2">mdi-check</v-icon>
                ACEPTAR
            </v-btn>
            <v-btn @click="descartaFoto" outlined class="mt-1 pa-5" width="163" color="secondary">
                <v-icon class="mr-2">mdi-delete-outline</v-icon>
                DESCARTAR
            </v-btn>
        </v-col>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
    data: () => ({
        width: 178,
        height: 178,
        capturado: false,
        overlay: false
    }),
    computed: {
        ...mapGetters('auth', ['nroafi', 'isAuthenticated']),
        ...mapGetters('dataUser', ['fototmp', 'fototmpcarnet']),
        ...mapGetters('preafiliacion', ['preafi', 'matricula']),
    },

    methods: {
        ...mapActions('dataUser', ['precargaFoto', 'subirFotoPerfil', 'guardarFotoCarnet', 'precargaFotoCarnet']),
        ...mapActions('preafiliacion', ['addFotoCarnet', 'guardarPreFotoCarnet']),
        ...mapActions('auth', ['validarImagen']),

        cargarFoto() {
            this.showCapture = false
            if (this.tipo == 'fotoperfil') {
                this.subirFotoPerfil({ nroafi: this.nroafi, fotoperfil: this.fototmp })
                //this.$emit('fotoCargada')
            } else if (this.tipo == 'fotocarnet') {
                //seguir aca
                if (this.isAuthenticated) {
                    this.guardarFotoCarnet(this.fototmp)
                    this.precargaFoto('')
                } else {
                    this.guardarPreFotoCarnet()
                    this.addFotoCarnet('')
                }
                //this.addFotoCarnet('')
                //   this.addFotoCarnet({ nroafi: this.matricula, fotocarnet: this.fototmp })
                //this.$emit('fotoCargada')
            }
            this.$emit('fotoCargada')

        },
        descartaFoto() {
            if (this.isAuthenticated) {
                if (this.tipo == 'fotoperfil') {
                    this.precargaFoto('')
                    this.$emit('fotoDescarta')
                } else {
                    // vacio fototmp
                    this.precargaFoto('')
                    this.$emit('fotoDescarta')
                }
            } else {
                this.addFotoCarnet('')
                this.$emit('fotoDescarta')
            }
        },
        async capture() {
            let constraints = {
                video: {
                    width: { ideal: 278 },  // Adjust width for vertical orientation
                    height: { ideal: 278 }, // Adjust height for vertical orientation
                    facingMode: 'user' // 'environment' for back camera, 'user' for front camera
                }
            };
            let capture = await navigator.mediaDevices.getUserMedia(constraints);
            let video = this.$refs.video;
            video.srcObject = capture;
            await video.play();
            let anchoVideo = video.videoWidth;
            let altoVideo = video.videoHeight;
            let canvas = this.$refs.canvas;
            let ctx = canvas.getContext('2d');
            canvas.width = anchoVideo;
            canvas.height = altoVideo;
            ctx.drawImage(video, 0, 0, anchoVideo, altoVideo);

            let dataURL = canvas.toDataURL('image/png');
            const formData = new FormData();
            formData.append('selfie', dataURL);
            formData.append('minBrightness', 50);
            formData.append('maxBrightness', 200);

            const valido = (this.tipo == "fotoperfil") ? true : await this.validarImagen(formData);

            if (valido) {
                (this.isAuthenticated) ? this.precargaFoto(dataURL.split(',')[1]) : this.addFotoCarnet(dataURL.split(',')[1]);
                this.capturado = true;
                canvas.style.display = '';
            } else {
                // Hide canvas and reset state if validation fails
                canvas.style.display = 'none';
                this.capturado = false;
            }
            // Probar antes de subir a master
            /*   if (video.srcObject) {
                  video.srcObject.getTracks().forEach(track => track.stop());
                  video.srcObject = null;
              } */

        },
    },
    mounted() {
        this.$nextTick(() => {
            let video = this.$refs.video;
            let constraints = {
                video: {
                    width: { ideal: 278 },  // Adjust width for vertical orientation
                    height: { ideal: 278 }, // Adjust height for vertical orientation
                    facingMode: 'user' // 'environment' for back camera, 'user' for front camera
                }
            };
            navigator.mediaDevices.getUserMedia(constraints)
                .then(stream => {
                    console.log(stream)
                    video.srcObject = stream
                    video.play()
                })
        })
    },
    props: ['tipo']
}
</script>